const $ = window.jQuery || {};

class Faq {
  constructor(selector) {
    this.$faqs = $(selector);
    this.$toc = $(".faq-toc-content");
    this.init();
  }

  init() {
    this.buildToc();

    this.$faqs.each((index, faq) => {
      const $faq = $(faq);
      const $title = $faq.find(".faq-title");

      $title.on("click", () => {
        this.toggle($faq);
      });
    });
  }

  buildToc() {
    this.$faqs.each((index, faq) => {
      const $faq = $(faq);
      const $title = $faq.find(".faq-title h3");
      const titleText = $title.text();

      // Generate an ID for the FAQ
      const id = "faq-" + index;
      $faq.attr("id", id);

      // Create a TOC item
      const $tocItem = $('<div class="toc-item"></div>');
      const $link = $("<a></a>")
        .attr("href", "#" + id)
        .text(titleText);

      $tocItem.append($link);
      this.$toc.append($tocItem);

      // Smooth scroll to the FAQ item
      $link.on("click", (e) => {
        e.preventDefault();
        $("html, body").animate(
          {
            scrollTop: $faq.offset().top,
          },
          500
        );
      });
    });
  }

  toggle($faq) {
    const $content = $faq.find(".faq-content");
    const isActive = $faq.hasClass("active");

    if (isActive) {
      $faq.removeClass("active");
      $content.slideUp();
    } else {
      $faq.addClass("active");
      $content.slideDown();
    }
  }
}

export default Faq;
